export { getWxJsConfig } from './getWxJsConfig';
export { getWxInfo } from './getWxInfo';
